<template>
  <div>
    <div class="form-container">
      <!-- row-1 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label1') }}<span class="form-row__colon">:</span></label>
        <p4a-input
          v-model="general.Name"
          class="folderName"
          :type="'text'"
          :size="'small'"
          :fullWidth="true"
          :leftIcon="''"
          :autofocus="true"
          :disabled="ReadOnly"
          @input="validateFolderName"
          :warning="{ visible: showFolderNameError,showIcon: true, message: $t('newFolder.errorMessage'), warningMessageOnBottom: true }"
        />
      </div>
      <!-- row-2 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label2') }}<span class="form-row__colon">:</span></label>
        <p class="form-row__section">{{ general.CreatedBy }}</p>
      </div>
      <!-- row-3 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label3') }}<span class="form-row__colon">:</span></label>
        <p class="form-row__section">{{ general.CreationDate.slice(0, 10)}} {{ general.CreationDate.slice(11, 19) }}</p>
      </div>
      <!-- row-4 -->
      <!-- row-4.1 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label4') }}<span class="form-row__colon">:</span></label>
        <p class="form-row__section">{{ general.FolderContents[0] }}</p>
      </div>
      <!-- row-4.2 -->
      <div class="form-row">
        <label class="form-row__label"></label>
        <p class="form-row__section">{{ general.FolderContents[1] }}</p>
      </div>
      <!-- row-4.3 -->
      <div class="form-row">
        <label class="form-row__label"></label>
        <p class="form-row__section">{{ general.FolderContents[2] }}</p>
      </div>
      <!-- row-5 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label5') }}<span class="form-row__colon">:</span></label>
        <select-drop-down
          :place-holder="general.metaDataSet.selected"
          :items="general.metaDataSet.items"
          :disabled="ReadOnly || !CanChangeMetadataSet"
          @onchange="updateMetaDataSet"
        />
        <!-- <p4a-input
          v-model="general.metaDataSet"
          class="input-w-button"
          :type="'text'"
          :inputSize="'small'"
          :fullWidth="true"
          :leftIcon="''"
          :autofocus="true"
        />
        <p4a-button
          class="smallRightButton"
          :showIcon="true"
          :onlyIconVisible="false"
          :icon="'connect'"
          :product="'ts'"
          :size="'small'"
          :disable="false"
          :text="$t('folderProperties.general.form.connectButton')">
        </p4a-button> -->
      </div>
      <!-- row-6 -->
      <div class="form-row">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label6') }}<span class="form-row__colon">:</span></label>
        <select-drop-down
          :place-holder="general.project.selected"
          :items="general.project.items"
          :disabled="ReadOnly || !CanChangeProject"
          @onchange="updateProject"
        />
        <!-- <p4a-input
          v-model="general.project"
          class="input-w-button"
          :type="'text'"
          :inputSize="'small'"
          :fullWidth="true"
          :leftIcon="''"
          :autofocus="true"
        /> -->
        <p4a-button
          @click="unLinkFolderToProject"
          class="smallRightButton"
          :fullWidth="true"
          :showIcon="false"
          :onlyIconVisible="false"
          :icon="'connect'"
          :product="'ts'"
          :size="'small'"
          :disable="ReadOnly || disableUnlinkProject"
          :text="$t('folderProperties.general.form.unlinkButton')">
        </p4a-button>
      </div>
      <!-- row-7 -->
      <div class="form-row" v-if="general.IsSnagstreamEnabled">
        <label class="form-row__label">{{ $t('folderProperties.general.form.label7') }}<span class="form-row__colon">:</span></label>
        <select-drop-down
          :place-holder="snagstreamPlaceholder(general.SnagstreamProjectId)"
          :items="getProjectsName(snagstreamProjects)"
          :disabled="ReadOnly || !CanChangeProject"
          @onchange="updateSnagstreamProject"
        />
      </div>
      <!-- row-8 -->
      <div class="form-row form-row__space">
        <p4a-checkbox
          class="checkbox-full"
          :value="'isProjectFolder'"
          :text="$t('folderProperties.general.form.checkbox1')"
          :checked="general.IsProjectFolder"
          :disabled="ReadOnly"
          @change="general.IsProjectFolder = !general.IsProjectFolder">
        </p4a-checkbox>
      </div>
      <!-- row-9 -->
      <div class="form-row">
        <p4a-checkbox
          class="checkbox-full"
          :value="'isTrustedFolder'"
          :text="$t('folderProperties.general.form.checkbox2')"
          :checked="general.IsConfidentialFolder"
          :disabled="ReadOnly"
          @change="general.IsConfidentialFolder = !general.IsConfidentialFolder">
        </p4a-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import selectDropDown from '../../dropdown/selectDropDown'
import * as treemenuApi from 'api/treemenuApi'
import mixins from 'mixins'
import _ from 'lodash'

export default {
  mixins: [mixins],
  components: { selectDropDown },
  props: {
    general: Object,
    ReadOnly: Boolean,
    CanChangeProject: Boolean,
    CanChangeMetadataSet: Boolean,
    currentProject: Object,
    disableUnlinkProject: Boolean,
    snagstreamProjects: Array
  },
  data () {
    return {
      showFolderNameError: false
    }
  },
  methods: {
    updateMetaDataSet (newValue) {
      this.general.metaDataSet.selected = newValue
    },
    updateProject (newValue) {
      this.general.project.selected = newValue
    },
    updateSnagstreamProject (newValue) {
      const translation = this.$i18n.t('folderProperties.general.form.notLinked')
      if (newValue === translation) {
        this.general.SnagstreamProjectId = null
      } else {
        const targetProject = _.find(this.snagstreamProjects, project => project['<Name>k__BackingField'] === newValue)
        this.general.SnagstreamProjectId = targetProject['<ProjectId>k__BackingField']
      }
    },
    unLinkFolderToProject () {
      treemenuApi.unlinkProject(this.currentProject).then(done => {
        this.reloadIframe('updateTreeView')
        this.general.project.selected = ''
        this.$emit('update:CanChangeProject', true)
        this.$emit('update:disableUnlinkProject', true)
      })
    },
    snagstreamPlaceholder (projectId) {
      const notLinkedTranslation = this.$i18n.t('folderProperties.general.form.notLinked')
      if (projectId === null || projectId === undefined) {
        return notLinkedTranslation
      } else {
        const targetProject = _.find(this.snagstreamProjects, project => project['<ProjectId>k__BackingField'] === projectId)
        if (targetProject) {
          return targetProject['<Name>k__BackingField']
        } else {
          return notLinkedTranslation
        }
      }
    },
    getProjectsName (snagstreamProjects) {
      if (snagstreamProjects && snagstreamProjects.length > 0) {
        return _.map(snagstreamProjects, '<Name>k__BackingField')
      } else {
        return []
      }
      // <ProjectId>k__BackingField
      // SnagstreamProjectId: this.general.SnagstreamProjectId
    },
    validateFolderName (value) {
      this.showFolderNameError = !this.validFolderName(value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/folder/folderProperties/generalProperties.vue